module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-7-58840830e19ede382192a4ac1e95da68.webp";